import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d29cd86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-lg-12 fv-row" }
const _hoisted_2 = { class: "required mb-2" }
const _hoisted_3 = { class: "fv-plugins-message-container text-start" }
const _hoisted_4 = { class: "fv-help-block" }
const _hoisted_5 = { class: "col-lg-12 fv-row" }
const _hoisted_6 = { class: "required mb-2" }
const _hoisted_7 = { class: "fv-plugins-message-container text-start" }
const _hoisted_8 = { class: "fv-help-block" }
const _hoisted_9 = { class: "d-flex justify-content-between mt-5" }
const _hoisted_10 = {
  type: "submit",
  class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px"
}
const _hoisted_11 = { class: "indicator-label" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode("Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VZMultiSelect = _resolveComponent("VZMultiSelect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Form = _resolveComponent("Form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.showModalVal,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showModalVal) = $event)),
    title: `${_ctx.t('pages.user.assignSite')}`,
    "close-on-click-modal": false,
    "close-on-press-escape": false,
    "destroy-on-close": true,
    onClose: _ctx.close
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["modal-body scroll-y bg-opacity-50 bg-light", [_ctx.widthClass, _ctx.heightClass]])
      }, [
        _createVNode(_component_Form, {
          class: "form w-100",
          id: "kt_modal_create_user_add_site",
          onSubmit: _ctx.submitData,
          "validation-schema": _ctx.addSiteSchema,
          ref: "addSiteRef"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Field, {
              modelValue: _ctx.userSites,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.userSites) = $event)),
              name: "site"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.t("common.sites")), 1),
                  _createVNode(_component_VZMultiSelect, {
                    element: {
                placeholder: 'Please select branch',
                options: _ctx.siteIdsOptions,
                multiSelect: true,
              },
                    modelValue: _ctx.userSites,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userSites) = $event))
                  }, null, 8, ["element", "modelValue"])
                ])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_ErrorMessage, { name: "site" })
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_Field, {
                modelValue: _ctx.siteRole,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.siteRole) = $event)),
                name: "role"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.t("common.roles")), 1),
                  _createVNode(_component_el_select, {
                    filterable: "",
                    placeholder: "Please select role",
                    modelValue: _ctx.siteRole,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.siteRole) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roleOptions, (option, index) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: index,
                          label: option.label,
                          value: option.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_ErrorMessage, { name: "role" })
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("button", {
                type: "reset",
                class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
              }, _toDisplayString(_ctx.t("common.close")), 1),
              _createElementVNode("button", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.t("common.save")), 1),
                _hoisted_12
              ])
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ], 2)
    ]),
    _: 1
  }, 8, ["modelValue", "title", "onClose"]))
}